export enum DailyDoseEnum {
  DAILY_DOSE = 'DAILY_DOSE',
  DOUBLE_DOSE = 'DOUBLE_DOSE',
  MEGA_DOSE = 'MEGA_DOSE',
  ULTRA_DOSE = 'ULTRA_DOSE',
  EPIC_DOSE = 'EPIC_DOSE',
}
